import "./GhostExamListMobileLoader.scss";

export const GhostExamListMobileLoader = () => {
  return (
      <>
          <div className="gcontainer-mobile">
              <div className="ghostlogo ganimate"></div>
              <div className="gduration_questions">
                  <div className="gduration ganimate"></div>
                  <div className="gquestions ganimate"></div>
              </div>
          </div>
      </>
  );
};
